export const GUIDES_SCROLL_STORAGE_KEY = "guides-articles-scroll-top";

export function saveGuidesScrollPosition() {
  const scrollEl = document.querySelector<HTMLElement>(".guides-articles-scroll");
  if (!scrollEl) return;
  sessionStorage.setItem(GUIDES_SCROLL_STORAGE_KEY, String(scrollEl.scrollTop));
}

export function restoreGuidesScrollPosition(container: HTMLElement | null) {
  const savedScroll = sessionStorage.getItem(GUIDES_SCROLL_STORAGE_KEY);
  if (!container || !savedScroll) return;

  const scrollTop = Number(savedScroll);
  if (!Number.isNaN(scrollTop)) {
    container.scrollTop = scrollTop;
  }
  sessionStorage.removeItem(GUIDES_SCROLL_STORAGE_KEY);
}
